import React from 'react';
import {
  Typography,
  Box,
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  Divider,
  Stack,
} from '@mui/material';
import { AccessTime as TimeIcon } from '@mui/icons-material';
import { useTimeFormat } from '../../context/TimeFormatContext';

export function Settings() {
  const { use24HourFormat, toggleTimeFormat } = useTimeFormat();

  return (
    <Box sx={{ maxWidth: 600 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Customize your Store Control experience
      </Typography>

      {/* Display Preferences */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <TimeIcon color="primary" />
            <Typography variant="subtitle1" fontWeight={600}>
              Display Preferences
            </Typography>
          </Stack>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="body1">Time Format</Typography>
              <Typography variant="body2" color="text.secondary">
                {use24HourFormat
                  ? 'Using 24-hour format (14:30)'
                  : 'Using 12-hour format (2:30 PM)'}
              </Typography>
            </Box>
            <FormControlLabel
              control={
                <Switch checked={use24HourFormat} onChange={toggleTimeFormat} color="primary" />
              }
              label={use24HourFormat ? '24h' : '12h'}
              labelPlacement="start"
            />
          </Box>
        </CardContent>
      </Card>

      {/* Version Info */}
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 4 }}>
        Byte Store Control v1.0.0
      </Typography>
    </Box>
  );
}
